import CrudManager from "@/components/admin/CrudManager";

export default function BlogsAdmin() {
  return (
    <CrudManager
      title="Blog Posts" subtitle="Manage travel guides and blog articles." testid="admin-blogs"
      endpoint={{ public: "/blogs", admin: "/admin/blogs" }} queryKey="blogs"
      columns={[
        { key: "image", label: "Image", render: (b) => <img src={b.image} alt="" className="h-10 w-16 object-cover rounded-lg" /> },
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "published", label: "Published" },
      ]}
      fields={[
        { key: "title", label: "Blog Title" },
        { key: "category", label: "Category" },
        { key: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
        { key: "body", label: "Body Content", type: "textarea", rows: 8 },
        { key: "image", label: "Featured Image URL", type: "image", full: true },
        { key: "meta_title", label: "Meta Title" },
        { key: "meta_description", label: "Meta Description", type: "textarea", rows: 2 },
        { key: "published", label: "Published", type: "checkbox", checkboxLabel: "Show on website" },
      ]}
    />
  );
}
